export default "__VITE_ASSET__CBZq26Nu__"